/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { SparkEngine } from '../models/SparkEngine';

export class ListSparkEnginesResponse {
  /**
  * List of Spark engines in the project
  */
  'sparkEngines': Array<SparkEngine>;
  'pagination'?: Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sparkEngines",
      "baseName": "sparkEngines",
      "type": "Array<SparkEngine>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSparkEnginesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

